// src/components/store/sections/newsletter/NewsletterV99PostcardstampSunsetAmber.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV99PostcardstampSunsetAmber(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={99}
      archKey="postcard_stamp"
      archLabel="Vintage Postcard Stamp"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
